import { Checkbox, Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const MeterTagField = ({ onSelect, value, disabled = false }) => {
	const tags = useSelector((store) => store.meterStore.tags);
	if (tags?.length === 1) {
		return (
			<Checkbox
				checked={value}
				onChange={(e) => {
					if (e.target.checked) {
						onSelect(tags[0].id);
					} else {
						onSelect(null);
					}
				}}
				disabled={disabled}
			>
				ОДПУ находится в котельной
			</Checkbox>
		);
	} else {
		return (
			<Select
				placeholder="Выберите тег"
				style={{ width: 250 }}
				value={value || undefined}
				onChange={onSelect}
				disabled={disabled}
			>
				{tags.map((tag) => {
					return (
						<Select.Option key={tag.id} value={tag.id}>
							{tag.name}
						</Select.Option>
					);
				})}
			</Select>
		);
	}
};

export default MeterTagField;
